import { Link } from 'react-router-dom';
import { relatedCalculateGuides } from '../data';

export default function RelatedGuidesSection() {
  return (
    <section id="related-guides" className="w-full bg-foreground-950 py-12 md:py-18">
      <div className="max-w-main mx-auto px-4 md:px-6">
        <div className="max-w-[640px] mb-10 md:mb-14">
          <h2 className="text-[32px] md:text-[42px] font-[750] leading-[1.15] text-foreground-100 tracking-tight mb-4">
            Now put the formula to work
          </h2>
          <p className="text-[15px] leading-relaxed text-foreground-400">
            You can calculate the total cost now. Dive into each piece individually — when you understand spread, commission, and swap separately, the formula becomes second nature.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {relatedCalculateGuides.map((guide) => (
            <Link
              key={guide.href}
              to={guide.href}
              className="group bg-foreground-900 rounded-card p-5 md:p-6 border border-foreground-800 hover:border-primary-700 transition-all duration-200 no-underline hover:-translate-y-1"
            >
              <h3 className="text-[16px] font-bold text-foreground-100 mb-2 group-hover:text-primary-400 transition-colors">
                {guide.title}
              </h3>
              <p className="text-[14px] leading-relaxed text-foreground-500">
                {guide.desc}
              </p>
              <div className="mt-4 text-[13px] font-semibold text-primary-500 group-hover:text-primary-400 transition-colors">
                Learn more
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}